export default __webpack_public_path__ + "static/media/diamond.a77fa4e6.png";